var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"client-app"}},[_c('router-view'),(_vm.showFloat)?_c('chat-float',{attrs:{"embed-mode":_vm.isEmbed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }